import { gql } from 'apollo-angular';

export const RemoveResourcePermissionDocument = gql`
  mutation removeResourcePermission($id: Int!) {
    removeResourcePermission(id: $id)
  }
`;
